var DisableASCIIkeys = [189,187,109,107,69];

$.fn.numeric = function(){
    var $this = $(this);
    $this.each(function(){
        // Set input type
        if(this.type != 'number') this.type = 'number'; 
    });
    $this.on('keydown', function(e) {
        var keyCode = e.keyCode || e.which;
        // Ignore keys
        if($.inArray(keyCode, DisableASCIIkeys) >= 0 ) e.preventDefault();
    });
}

$('.js-input--numeric').numeric();
$('input[type=number]').numeric();